import { useContext } from 'react'
import { DisplayContext } from '../DisplayContext'
import { ParentContext } from '../ParentContext';
import { FrameworkContext } from '../FrameworkContent';
import { UiItemContext } from '../UiItemContext';
import { FilterContext } from '../FilterContext';

export const useDisplay = ({ selectedGroupItem = null } = {}) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { page_state, paps_state } = states
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  // papsContext 
  const { ddGroupIndex, ddGroupKey, ddProps } = paps_state ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { desktopMode } = framework_state ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { props_viewItem } = item_state

  // filterContext
  const filterContext = useContext(FilterContext);
  const { uiFilter_state } = filterContext ?? {}
  const { groupDataProps } = uiFilter_state ?? {}

  const { layout, desktopLayout } = aps_page ?? {}
  const _layout = desktopMode ? desktopLayout : layout

  const { groups } = groupDataProps ?? {}

  const displayProps = {
    ddGroupIndex,
    ddGroupKey,
    ddProps,
    dragMode: false,
    groups,
    selectedGroupItem,
    props_viewItem,
    layout_page: _layout,
  }

  // const display_state = { displayProps }

  // const displayContext = useContext(DisplayContext)
  // const { display_state } = displayContext ?? {}
  // const { displayProps, ddGroupIndex, ddGroupKey, ddProps } = display_state ?? {} 
  return { displayProps, ddGroupIndex, ddGroupKey, ddProps }
}
